<template>
  <div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="filter" id="filter1"
        @change="$emit('input', 'running')" :checked="value === 'running'"
      >
      <label class="form-check-label" for="filter1">Running {{ type === 'trial' ? 'Tests' : 'Roll Outs'}}</label>
    </div>
    <div class="form-check form-check-inline" v-if="type === 'trial'">
      <input class="form-check-input" type="radio" name="filter" id="filter2"
        @change="$emit('input', 'rolled_out')" :checked="value === 'rolled_out'"
      >
      <label class="form-check-label" for="filter2">Rolled Out Tests</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="filter" id="filter3"
        @change="$emit('input', 'archived')" :checked="value === 'archived'"
      >
      <label class="form-check-label" for="filter3">Archived {{ type === 'trial' ? 'Tests' : 'Roll Outs'}}</label>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: null,
      type: {
        default: 'trial'
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/TrialsTableFilter.vue